<template>
  <div class="col-xs-12 p-x-0" :class="setting.class" :id="setting.id">
    <div class="j-mutiple-left">
      <select name="from" id="multiselect" class="form-control" size="8" >
        <option v-for="(option, index) in setting.options" :value="option.value" :class="'o-' + option.value">
          {{option.label}}
        </option>
      </select>
    </div>
    <div class="j-mutiple-middle">
      <!-- <button type="button" :id="'multiselect_rightAll-' + setting.class" class="btn btn-block" @click="isChoose = true"><i class="fa fa-forward"></i></button> -->
      <button type="button" :id="'multiselect_rightSelected-'+ setting.class" class="btn btn-block" @click="isChoose = true"><i class="fa fa-chevron-right"></i></button>
      <button type="button" :id="'multiselect_leftSelected-' + setting.class" class="btn btn-block" @click="isChoose = true"><i class="fa fa-chevron-left"></i></button>
      <!-- <button type="button" :id="'multiselect_leftAll-' + setting.class" class="btn btn-block" @click="isChoose = true"><i class="fa fa-backward"></i></button> -->
    </div>
    <div class="j-mutiple-right">
      <select name="to" :id="'multiselect_to-' + setting.class" class="form-control" size="8" multiple="multiple">
      </select>
    </div>
    <div class="col-xs-12 text-right">
      <p class="text-12">已選 {{this.setting.choose.length}} 間</p>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'

export default {
  props: {
    setting: {
      type: Object,
      required: true
    },
    reNew: Number,
    reSet: Number
  },
  data () {
    return {
      selected: 0,
      inputValue: '',
      elementRemark: '',
      first: true,
      isChoose: false
    }
  },
  mounted () {
    if (this.$route.name === 'crSchedule') this.first = false
    // set up miltselect
    var self = this
    $('.' + self.setting.class + ' #multiselect').multiselect({
      right: '#multiselect_to-' + self.setting.class,
      rightAll: '#multiselect_rightAll-' + self.setting.class,
      rightSelected: '#multiselect_rightSelected-' + self.setting.class,
      leftSelected: '#multiselect_leftSelected-' + self.setting.class,
      leftAll: '#multiselect_leftAll-' + self.setting.class,
      afterMoveToLeft: function ($left, $right, $options) {
        self.setting.choose = []
        $('.' + self.setting.class + ' #multiselect_to-' + self.setting.class + ' option').each(function () {
          self.setting.choose.push(parseInt($(this).val(), 10))
        })
      },
      afterMoveToRight: function ($left, $right, $options) {
        self.setting.choose = []
        $('.' + self.setting.class + ' #multiselect_to-' + self.setting.class + ' option').each(function () {
          self.setting.choose.push(parseInt($(this).val(), 10))
        })
      },
      search: {
        left: '<input type="text" name="q-' + self.setting.class + '" class="form-control" placeholder="搜尋..." />',
        right: '<input type="text" name="q-' + self.setting.class + '" class="form-control" placeholder="搜尋..." />'
      },
      fireSearch: function (value) {
        return value.length > 0
      }
    })
  },
  methods: {
    init () {
      const self = this
      self.$nextTick(function () {
        // 重設定option
        $('.' + self.setting.class + ' #multiselect option').remove()
        $('.' + self.setting.class + ' #multiselect_to-' + self.setting.class + ' option').remove()
        this.setting.options.forEach(function (option) {
          var o = new Option(option.label, option.value)
          $('.' + self.setting.class + ' #multiselect').append(o)
        })
        // 設定選取
        this.setting.choose.forEach(function (choseVal, index) {
          var oObj = self.setting.options.find(function (option) { return choseVal === option.value })
          if (oObj) {
            var o = new Option(oObj.label, oObj.value)
            $('.' + self.setting.class + ' #multiselect_to-' + self.setting.class).append(o)
            if (index === self.setting.choose.length - 1) self.first = false
            $('.' + self.setting.class + ' #multiselect option[value="' + oObj.value + '"]').remove()
          }
        })
      })
    }
  },
  watch: {
    reSet () {
      this.first = true
    },
    reNew () {
      var self = this
      $('.' + self.setting.class + ' #multiselect option').remove()
      // 重設定option
      if (this.$route.name === 'crActivityInfoForm') {
        this.setting.options.forEach(function (option) {
          var o = new Option(option.label, option.value)
          $('.' + self.setting.class + ' #multiselect').append(o)
        })
      }
    },
    'setting.choose' () {
      var self = this
      self.$nextTick(function () {
        var rName = this.$route.name
        if (!this.setting.choose.length) $('.' + self.setting.class + ' #multiselect_to-' + self.setting.class + ' option').remove()
        if (
        !self.isChoose && (
          (self.first && this.$route.name.indexOf('up') > -1 && this.setting.choose.length && this.$route.name !== 'upStore') ||
          (rName === 'crStoreClass' && self.first && this.setting.choose.length) ||
          (rName === 'crSchedule' && self.first && this.setting.choose.length) ||
          (rName === 'upSchedule' && self.first && this.setting.choose.length) ||
          (rName === 'upDiscount' && self.first && this.setting.choose.length) ||
          (rName === 'crDiscount' && self.first && this.setting.choose.length) ||
          (rName === 'crActivityInfoForm' && self.first && this.setting.choose.length) ||
          (rName === 'upActivity' && self.first && this.setting.choose.length) ||
          (rName === 'storeGroup' && self.first && this.setting.choose.length) ||
          (rName === 'crBrandAd' && self.first && this.setting.choose.length) ||
          (rName === 'upBrandAd' && self.first && this.setting.choose.length)
        )
        ) {
          this.setting.choose.forEach(function (choseVal, index) {
            var oObj = self.setting.options.find(function (option) { return choseVal === option.value })
            if (oObj) {
              var o = new Option(oObj.label, oObj.value)
              $('.' + self.setting.class + ' #multiselect_to-' + self.setting.class).append(o)
              if (index === self.setting.choose.length - 1) self.first = false
              $('.' + self.setting.class + ' #multiselect option[value="' + oObj.value + '"]').remove()
            }
          })
        }
        self.isChoose = false
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.j-mutiple-left, .j-mutiple-right
  float: left
  width: calc(50% - 30px)
  select
    height: 166px
    min-height: 166px
    overflow: scroll
.j-mutiple-middle
  float: left
  width: 40px
  margin: 0px 10px
</style>



// WEBPACK FOOTER //
// jMutiSelect_v2.vue?97ddc6ea